import React from 'react'
import { AGE_INTEGER_FILTER_FEATURE_ENTRY_POINT_BANNER_IMAGES } from '@moonpig/web-core-brand/config'
import { InputFilterEntryPointBanner } from '../../InputFilterEntryPointBanner'
import { useFindLocaleText } from '../../../text-localisation'

export const AgeInputFilterBanner = () => {
  const localiseText = useFindLocaleText()

  return (
    <InputFilterEntryPointBanner
      title={localiseText('find.age_integer_filter_banner.heading')}
      description={localiseText('find.age_integer_filter_banner.description')}
      images={{
        xs: AGE_INTEGER_FILTER_FEATURE_ENTRY_POINT_BANNER_IMAGES.xs,
        md: AGE_INTEGER_FILTER_FEATURE_ENTRY_POINT_BANNER_IMAGES.md,
        description: localiseText('find.age_integer_filter_banner.description'),
      }}
      ctaTitle={localiseText('find.age_integer_filter_banner.cta_title')}
      filter={{
        integerId: 'age',
        id: 'integer-birthday milestones',
      }}
    />
  )
}
